import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, from, throwError } from 'rxjs';
import { take, mergeMap, tap, catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
    
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        public toastController: ToastController
        ) {
    }
    
    // Intercepts all HTTP requests!
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        // Only set autorization header on /private/
        if (request.url.indexOf('/private/') < 0) {
            return next.handle(request);
        } else {
            return from(this.authenticationService.getToken()).pipe(
                take(1), 
                mergeMap(token => {
                    let clonedReq = this.addToken(request, token);
                    return next.handle(clonedReq).pipe(
                        catchError(error => {
                            if (error instanceof HttpErrorResponse && error.status === 401 && ! clonedReq.url.includes('/private/users/me')) {
                                this.authenticationService.logout().then(async () => {
                                    this.router.navigate(['login']);
                                    const toast = await this.toastController.create({
                                        message: 'Din inloggningstid har gått ut. Vänligen logga in igen.',
                                        color: 'light',
                                        position: 'top',
                                        duration: 3000
                                      });
                                      toast.present();
                                });

                                return of(null);
                            }
                            else {
                                return throwError(error);
                            }
                        })
                    );
                })
            );
        }
    }
    
    // Adds the token to your headers if it exists
    private addToken(request: HttpRequest<any>, token: any) {
        if (token) {
            let clone: HttpRequest<any>;
            clone = request.clone({
                setHeaders: {
                    Accept: `application/json`,
                    'Content-Type': `application/json`,
                    Authorization: `Bearer ${token}`
                }
            });
            return clone;
        }
  
        return request;
    }
  

}